import { Injectable } from '@angular/core';
import { MyDelegationsDto } from '@osos/shared/api';
import { DelegationPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { DelegationParserV1Service } from '../../parsers/index';
import { ParserFactory } from '../../services';

@Injectable()
export class DelegationFactoryService extends FactoryBase<
  MyDelegationsDto,
  DelegationPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parseV1: DelegationParserV1Service,
  ) {
    super(parserFactory);
    parserFactory.register(parseV1);
  }
  createDataModel(presenter: DelegationPresenterModel): MyDelegationsDto {
    const parser = this.getParser(
      MyDelegationsDto,
      DelegationPresenterModel,
      1,
    );

    return parser.getDataModel(presenter);
  }
  createPresenterModel(
    model: MyDelegationsDto | any,
  ): DelegationPresenterModel {
    const parser = this.getParser(
      MyDelegationsDto,
      DelegationPresenterModel,
      model.specificationVersion,
    );
    return parser?.getPresenterModel(model);
  }
}
